export default "__VITE_ASSET__Dzgk_LDW__"